<template>
    <b-modal size="lg" id="shopware_to_exact_manager_modal">
        <template slot="modal-title">Manage Shopware to Exact online config</template>
        <v-app class="v-appNoBackground v-app">
            <b-form ref="shopware_to_exact_manager_modal_form">
                <b-form-group label="The name of the email field for an invoice.">
                    <b-form-input
                            id="InvoiceEmail"
                            placeholder="email_field"
                            :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.emailInvoiceFieldName)"
                            v-model="shopware5_6ToExactOnline1Config.emailInvoiceFieldName"/>
                </b-form-group>

                <hr/>
                <h3>Customer groups mapping</h3>
                <hr/>

                <b-form-group>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <b-form-group label="B2B customer groups in Shopware.">
                                <b-form-input
                                        v-for="(group, index) in shopware5_6ToExactOnline1Config.customerGroups.b2b"
                                        id="b2bGroup"
                                        placeholder="H"
                                        name="shopware5_6ToExactOnline1Config.customerGroups.b2b[]"
                                        :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.customerGroups.b2b[index])"
                                        v-model="shopware5_6ToExactOnline1Config.customerGroups.b2b[index]"
                                        :value="group"
                                        required/>
                            </b-form-group>
                            <v-btn icon @click='shopware5_6ToExactOnline1Config.customerGroups.b2b.push("")'>
                                <v-icon color="success">mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn icon @click='shopware5_6ToExactOnline1Config.customerGroups.b2b.pop()'>
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>

                        <div class="col-12 col-md-6">
                            <b-form-group label="B2C customer groups in Shopware.">
                                <b-form-input
                                        v-for="(group, index) in shopware5_6ToExactOnline1Config.customerGroups.b2c"
                                        id="b2cGroup"
                                        placeholder="EK"
                                        name="shopware5_6ToExactOnline1Config.customerGroups.b2c[]"
                                        :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.customerGroups.b2c[index])"
                                        v-model="shopware5_6ToExactOnline1Config.customerGroups.b2c[index]"
                                        :value="group"
                                        required/>
                            </b-form-group>
                            <v-btn icon @click='shopware5_6ToExactOnline1Config.customerGroups.b2c.push("")'>
                                <v-icon color="success">mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn icon @click='shopware5_6ToExactOnline1Config.customerGroups.b2c.pop()'>
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </b-form-group>

                <hr/>
                <h3>Payment condition mapping</h3>
                <hr/>

                <b-form-group>
                    <b-form-group label="Fallback for payment condition.">
                        <b-form-input
                                id="FallbackPaymentCondition"
                                placeholder="14"
                                :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.paymentConditions.fallback)"
                                v-model="shopware5_6ToExactOnline1Config.paymentConditions.fallback"
                                required/>
                    </b-form-group>

                    <div class="row">
                        <p class="col-5">Shopware payment ID</p>
                        <p class="col-5">Exact online payment condition ID</p>
                        <p class="col-1">Delete</p>
                    </div>
                    <div class="row"
                         v-for="(paymentId) in objectKeys(shopware5_6ToExactOnline1Config.paymentConditions)"
                         v-if="paymentId !== 'fallback'"
                         :key="componentKey">
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input :value="paymentId" readonly/>
                            </b-form-group>
                        </div>
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input
                                        id="paymentCondition"
                                        placeholder="IN"
                                        :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.paymentConditions[paymentId])"
                                        v-model="shopware5_6ToExactOnline1Config.paymentConditions[paymentId]"
                                        @change="forceRerender()"
                                        required/>
                            </b-form-group>
                        </div>
                        <div class="col-1 lowProfileRow">
                            <v-btn icon
                                   @click="forceRerender(), delete shopware5_6ToExactOnline1Config.paymentConditions[paymentId]">
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <b-form-group label="Add new payment condition mapping">
                        <div class="row">
                            <div class="col-10">
                                <b-form-input id="newPaymentIdForCondition"
                                              placeholder="5"
                                              class="form-control-sm"
                                              v-model="tempVars.newPaymentIdField"/>
                            </div>
                            <div class="col-2">
                                <v-btn icon
                                       @click='forceRerender(), shopware5_6ToExactOnline1Config.paymentConditions[tempVars.newPaymentIdField] = "", tempVars.newPaymentIdField = ""'
                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newPaymentIdField)">
                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </b-form-group>
                </b-form-group>

                <hr/>
                <h3>Advanced Shopware Tax to Exact VAT code mapping</h3>
                <hr/>

                <b-form-group>
                    <div class="row">
                        <div class="col-6">
                            <b-form-group label="Fallback for Tax map.">
                                <b-form-input
                                        id="fallbackTaxCode"
                                        placeholder="0"
                                        :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap.fallback)"
                                        v-model="shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap.fallback"
                                        required/>
                            </b-form-group>
                        </div>
                        <div class="col-6">
                            <b-form-group label="Tax free VAT code.">
                                <b-form-input
                                        id="noTaxCode"
                                        placeholder="0"
                                        :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap.noTax)"
                                        v-model="shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap.noTax"
                                        required/>
                            </b-form-group>
                        </div>
                    </div>
                    <div v-for="(taxMap) in objectKeys(shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap)"
                         v-if="taxMap !== 'fallback' && taxMap !== 'noTax'"
                         :key="componentKey">
                        <h4>VAT map for shopware Tax id : {{taxMap}}</h4>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <h5>VAT number filled in codes</h5>
                                <b-form-group>
                                    <div class="row">
                                        <p class="col-5">Country iso code</p>
                                        <p class="col-5">Exact VAT code</p>
                                        <p class="col-1">Delete</p>
                                    </div>
                                    <div class="row"
                                         v-for="(vatFilledIn) in objectKeys(shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatFilledIn)"
                                         :key="componentKey">
                                        <div class="col-5 lowProfileRow">
                                            <b-form-group>
                                                <b-form-input :value="vatFilledIn" readonly/>
                                            </b-form-group>
                                        </div>
                                        <div class="col-5 lowProfileRow">
                                            <b-form-group>
                                                <b-form-input
                                                        id="VatFilledInVatCode"
                                                        placeholder="8"
                                                        :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatFilledIn[vatFilledIn])"
                                                        v-model="shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatFilledIn[vatFilledIn]"
                                                        @change="forceRerender()"
                                                        required/>
                                            </b-form-group>
                                        </div>
                                        <div class="col-1 lowProfileRow">
                                            <v-btn icon v-if="vatFilledIn !== 'EU' && vatFilledIn !== 'NonEU'"
                                                   @click="forceRerender(), delete shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatFilledIn[vatFilledIn]">
                                                <v-icon color="error">mdi-minus-circle</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                    <hr/>
                                    <b-form-group label="Add new ISO country to mapping">
                                        <div class="row">
                                            <div class="col-10">
                                                <b-form-input id="newVatFilledIn"
                                                              placeholder="DE"
                                                              class="form-control-sm"
                                                              v-model="tempVars.newVatFilledIn"/>
                                            </div>
                                            <div class="col-2">
                                                <v-btn icon
                                                       @click='forceRerender(), shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatFilledIn[tempVars.newVatFilledIn] = ""'
                                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newVatFilledIn)">
                                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </b-form-group>
                                </b-form-group>
                            </div>
                            <div class="col-12 col-md-6">
                                <h5>VAT number not filled in codes</h5>
                                <b-form-group>
                                    <div class="row">
                                        <p class="col-5">Country iso code</p>
                                        <p class="col-5">Exact VAT code</p>
                                        <p class="col-1">Delete</p>
                                    </div>
                                    <div class="row"
                                         v-for="(vatNotFilledIn) in objectKeys(shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatNotFilledIn)"
                                         :key="componentKey">
                                        <div class="col-5 lowProfileRow">
                                            <b-form-group>
                                                <b-form-input :value="vatNotFilledIn" readonly/>
                                            </b-form-group>
                                        </div>
                                        <div class="col-5 lowProfileRow">
                                            <b-form-group>
                                                <b-form-input
                                                        id="VatNotFilledInVatCode"
                                                        placeholder="7"
                                                        :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatNotFilledIn[vatNotFilledIn])"
                                                        v-model="shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatNotFilledIn[vatNotFilledIn]"
                                                        @change="forceRerender()"
                                                        required/>
                                            </b-form-group>
                                        </div>
                                        <div class="col-1 lowProfileRow">
                                            <v-btn icon v-if="vatNotFilledIn !== 'EU' && vatNotFilledIn !== 'NonEU'"
                                                   @click="forceRerender(), delete shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatNotFilledIn[vatNotFilledIn]">
                                                <v-icon color="error">mdi-minus-circle</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                    <hr/>
                                    <b-form-group label="Add new ISO country to mapping">
                                        <div class="row">
                                            <div class="col-10">
                                                <b-form-input id="newVatNotFilledIn"
                                                              placeholder="NL"
                                                              class="form-control-sm"
                                                              v-model="tempVars.newVatNotFilledIn"/>
                                            </div>
                                            <div class="col-2">
                                                <v-btn icon
                                                       @click='forceRerender(), shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[taxMap].vatNotFilledIn[tempVars.newVatNotFilledIn] = ""'
                                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newVatNotFilledIn)">
                                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </b-form-group>
                                </b-form-group>
                            </div>
                        </div>
                        <hr/>
                    </div>
                    <b-form-group label="Add new Tax to VAT map for Shopware Tax id">
                        <div class="row">
                            <div class="col-10">
                                <b-form-input id="newVatMap"
                                              placeholder="12"
                                              class="form-control-sm"
                                              v-model="tempVars.newShopwareVatCode"/>
                            </div>
                            <div class="col-2">
                                <v-btn icon
                                       @click='forceRerender(), shopware5_6ToExactOnline1Config.ShopwareTaxToExactVatCodeMap[tempVars.newShopwareVatCode] = {vatFilledIn:{EU:null, NonEU:null},vatNotFilledIn:{EU:null, NonEU:null}}, tempVars.newShopwareVatCode = ""'
                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newShopwareVatCode)">
                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </b-form-group>
                </b-form-group>

                <hr/>
                <h3>Payment to customer map</h3>
                <hr/>

                <b-form-group>
                    <div class="col-12">
                        <b-form-group label="Fallback for customer map.">
                            <b-form-input
                                    id="fallbackTaxCode"
                                    placeholder="0"
                                    :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.PaymentMethodToCustomer.fallback)"
                                    v-model="shopware5_6ToExactOnline1Config.PaymentMethodToCustomer.fallback"
                                    required/>
                        </b-form-group>
                    </div>
                    <div class="row"
                         v-for="(paymentMethod) in objectKeys(shopware5_6ToExactOnline1Config.PaymentMethodToCustomer.list)"
                         :key="componentKey">
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input :value="paymentMethod" readonly/>
                            </b-form-group>
                        </div>
                        <div class="col-5 lowProfileRow">
                            <b-form-group>
                                <b-form-input
                                        id="CustomerIdForPaymentMethod"
                                        placeholder="c3dd531b-8a90-431b-87b8-fb7b386aca9a"
                                        :state="isNotNullAndUndefinedAndEmpty(shopware5_6ToExactOnline1Config.PaymentMethodToCustomer.list[paymentMethod])"
                                        v-model="shopware5_6ToExactOnline1Config.PaymentMethodToCustomer.list[paymentMethod]"
                                        @change="forceRerender()"
                                        required/>
                            </b-form-group>
                        </div>
                        <div class="col-1 lowProfileRow">
                            <v-btn icon
                                   @click="forceRerender(), delete shopware5_6ToExactOnline1Config.PaymentMethodToCustomer.list[paymentMethod]">
                                <v-icon color="error">mdi-minus-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <b-form-group label="Add new payment method to customer mapping">
                        <div class="row">
                            <div class="col-10">
                                <b-form-input id="newPaymentMethodMap"
                                              placeholder="5"
                                              class="form-control-sm"
                                              v-model="tempVars.newPaymentMethodForCustomer"/>
                            </div>
                            <div class="col-2">
                                <v-btn icon
                                       @click='forceRerender(), shopware5_6ToExactOnline1Config.PaymentMethodToCustomer.list[tempVars.newPaymentMethodForCustomer] = "", tempVars.newPaymentMethodForCustomer = ""'
                                       :disabled="!isNotNullAndUndefinedAndEmpty(tempVars.newPaymentMethodForCustomer)">
                                    <v-icon color="success">mdi-plus-circle</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </b-form-group>
                </b-form-group>
            </b-form>
            <i>*Makes sure all the field are present, does not validate their value.</i>
        </v-app>
        <template slot="modal-footer">
            <b-button block
                      variant="secondary"
                      @click="forceRerender">
                Check required fields
                <v-icon dark>mdi-file-document-box-search-outline</v-icon>
                *
            </b-button>
            <v-divider vertical/>
            <b-button block
                      variant="primary"
                      @click="save">
                Save config
                <v-icon dark>mdi-content-save-outline</v-icon>
            </b-button>
        </template>
    </b-modal>
</template>
<script>
    import ProjectRepository from '../../../repositories/project.repository'

    export default {
        props: {
            projectConfig: {
                type: Object,
                default: () => {
                }
            },
            projectId: {
                type: Number,
                default: -1
            }
        },
        data() {
            return {
                componentKey: 0,
                tempVars: {
                    newPaymentIdField: null,
                    newPaymentIdForPaymentStatusField: null,
                    newShopwareVatCode: null,
                    newPaymentMethodForCustomer: null,
                    newVatFilledIn: null,
                    newVatNotFilledIn: null
                },
                shopware5_6ToExactOnline1Config: {
                    customerGroups: {b2b: [""], b2c: [""]},
                    emailInvoiceFieldName: null,
                    paymentConditions: {fallback: null,},
                    ShopwareTaxToExactVatCodeMap: {fallback: null, noTax: null},
                    PaymentMethodToCustomer: {fallback: null, list: {}}
                },
            }
        },
        methods: {
            save() {
                this.forceRerender();
                if (this.$refs.shopware_to_exact_manager_modal_form.checkValidity()) {
                    this.projectConfig.shopware5_6ToExactOnline1Config = this.shopware5_6ToExactOnline1Config;
                    this.$emit('show-loading-pop-up', "Saving the project Config");
                    this.$bvModal.hide('shopware_to_exact_manager_modal');
                    ProjectRepository.saveProjectConfig(this.projectConfig, this.projectId).then(res => {
                        this.$emit('reset-loading-pop-up');
                        this.$emit('saved-project-config');
                        this.$bvToast.toast('Successfully saved the project config', {
                            title: `Config save successful.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$bvModal.show('shopware_to_exact_manager_modal');
                        console.error(error);
                        this.$bvToast.toast('Looks like something went wrong on the server while saving the project config.', {
                            title: `Config save error.`,
                            variant: 'danger',
                            solid: true
                        });
                    });
                }
            },
            isNotNullAndUndefinedAndEmpty(value) {
                return (value !== undefined && value !== null && value !== "");
            },
            objectKeys(val) {
                return Object.keys(val);
            },
            forceRerender() {
                this.componentKey++;
            }
        },
        watch: {
            projectConfig() {
                if (this.projectConfig.shopware5_6ToExactOnline1Config !== undefined) {
                    this.shopware5_6ToExactOnline1Config = this.projectConfig.shopware5_6ToExactOnline1Config;
                }
            }
        }
    }
</script>

<style>
    .lowProfileRow {
        padding-bottom: 1px !important;
        padding-top: 1px !important;
    }
</style>
